import React from 'react';
import { Router, Link, browserHistory } from 'react-router';
import { Meteor } from 'meteor/meteor';

import {
  Button,
  FormControl,
  Checkbox,
  BPanel,
  FormGroup,
} from '@sketchpixy/rubix';

import { Memos } from '../../../collections/memos/memos';

export class MemoComponent extends React.Component {

    constructor(props) {
        super(props);
        this.state = {};
    }


  	changeMemoInfos(event) {
      console.log("test");
  		//Memos.update(event.target.id, { "$set": {content: event.target.value}});
  	}

  	render() {
  	  	return (
          <div className="calendar-memo">
            <BPanel header="Mémo">
            <FormGroup controlId="formControlsTextarea">
              <FormControl style={{height: '200px', border: 'none'}} ref="memo" id={this.props.memo._id} defaultValue={this.props.memo.content} onChange={this.changeMemoInfos.bind(this)} type="text" componentClass="textarea" />
            </FormGroup>
            </BPanel>
          </div>
  	  	);
      }
}

MemoComponent.propTypes = {
  memo: React.PropTypes.object.isRequired,
};



/** WEBPACK FOOTER **
 ** ./src/universal/components/reservations/components/component-memo.js
 **/